import { Receipt } from 'lucide-react';

/**
 * Read-only badge showing the billing party for invoices/estimates.
 * Renders nothing when no billing relationship exists.
 */
export function BillingBadge({ billingCustomer, className }) {
  if (!billingCustomer) return null;

  return (
    <div
      className={`flex items-start gap-2 rounded-md border border-amber-200 bg-amber-50 dark:bg-amber-950/30 dark:border-amber-800 px-3 py-2 ${className || ''}`}
      data-testid="billing-badge"
    >
      <Receipt className="w-4 h-4 shrink-0 mt-0.5 text-amber-600 dark:text-amber-400" />
      <div className="text-xs">
        <p className="font-semibold text-amber-800 dark:text-amber-300">
          Bill To: {billingCustomer.display_name}
        </p>
        {billingCustomer.billing_email && (
          <p className="text-amber-700 dark:text-amber-400">{billingCustomer.billing_email}</p>
        )}
        {billingCustomer.billing_address && (
          <p className="text-amber-600 dark:text-amber-500">{billingCustomer.billing_address}</p>
        )}
      </div>
    </div>
  );
}
